export const pt = {
    title: `Bem-vindo de volta`,
    description: `Digite suas credenciais para acessar sua conta`,
    forgotPassword: `Esqueceu sua senha?`,
    noAccount: `Não tem uma conta?`,
    failure: `Falha ao entrar`,
};
//# sourceMappingURL=pt.js.map